import React from 'react';
import './NewFrontiers.css';

// Import the new image
import frontiersImage from '../../assets/images/new-frontiers.jpg';

const NewFrontiers = () => {
  return (
    <section className="new-frontiers-section">
      <div className="new-frontiers-container">
        {/* Left Column: Image */}
        <div className="frontiers-image-col">
          <img src={frontiersImage} alt="Team exploring new business frontiers" />
        </div>

        {/* Right Column: Text Content */}
        <div className="frontiers-text-col">
          <h2>Expand adjacencies & explore new frontiers (disruption)</h2>
          <p>
            We work with you to expand beyond the core identifying opportunities in adjacent and emerging markets, whether through enhanced offerings or strategic M&A. It begins with a solid business case backed by rigorous market assessment and opportunity evaluation.
          </p>
          <p>
            From there, we craft a detailed business plan and translate it into a strategic action roadmap designed to guide execution and accelerate decisions. Alongside, we define a capability and capacity roadmap to ensure you’re equipped to scale to the next horizon of growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewFrontiers;